import {MutationTree} from "vuex";
import {PriorityRulesState} from "@/store/settings/priority_rules/types";

export const mutations: MutationTree<PriorityRulesState> = {
  pushPriorityRules:(state, payload) => {
    state.priorityRules = state.priorityRules.concat(payload)
  },
  setPriorityRules:(state, payload) => {
    state.priorityRules = payload
  },
  setPriorityRuleItem:(state, payload) => {
    state.priorityRuleItem = payload
  }
}
